import React from 'react';
import { InteractiveNonRectangularShape } from '../interactive/InteractiveNonRectangularShape';
import storeManager from '../../../store/StoreManager';
import { hideMenus, setContextTarget } from '../../../actions/MenuActions';
import menuType from '../../../constants/MenuType';
import mouseUtils from '../../utils/MouseUtils';
import { selectShape } from '../../../actions/CurrentSlideActions';

export const Curve = React.createClass({
    propTypes: {
        dispatch: React.PropTypes.func.isRequired,
        shapeModel: React.PropTypes.object.isRequired
    },
    createNewPath (shapeModel) {
        const x = Math.min (shapeModel.x1, shapeModel.x2);
        const y = Math.min (shapeModel.y1, shapeModel.y2);
        const path = `M${shapeModel.x1 - x},${shapeModel.y1 - y}Q${shapeModel.cx - x},${shapeModel.cy - y},${shapeModel.x2 - x},${shapeModel.y2 - y}`;

        return path;
    },
    isShapeSelected() {
        const state = storeManager.getState();
        const shapes = state.currentSlide.model.content;
        var i;

        for (i=0; i<shapes.length; i++)
            if (shapes[i].uuid == this.props.shapeModel.uuid) {
                if (shapes[i].isSelected == true)
                    return true;
                else
                    return false;
            }

        return false;
    },
    onKeyDown(e) {
        if (e.keyCode == 13) { // ENTER
            setTimeout(function() {
                this.props.dispatch(hideMenus([menuType.ALL_MENUS]));
                this.props.dispatch(setContextTarget(this.props.shapeModel));

                setTimeout(function() {
                    var buttonMenu = document.getElementById('shapeMenuFirstElement');

                    if (buttonMenu)
                        buttonMenu.focus();
                }.bind(this), 20);
            }.bind(this), 20);
        }
    },
    onFocusHandler() {
        if (document.activeElement == this.refs.focusableElement) {
            if (!this.isShapeSelected())
                this.props.dispatch(selectShape(this.props.shapeModel.uuid));

            mouseUtils.activeElement = this.props.shapeModel.uuid;
        }
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties)
            return true;
        else
            return false;
    },
    render () {
        const { shapeModel, dispatch } = this.props;

        const path = this.createNewPath(shapeModel);

        return (
            <InteractiveNonRectangularShape shapeModel={shapeModel} dispatch={dispatch} scaleProperties={this.props.scaleProperties}>
                <g>
                    <path
                        d={path}
                        filter={shapeModel.filter}
                        opacity={shapeModel.opacity}
                        fill='#ffffff'
                        fillOpacity='0'
                        stroke={shapeModel.stroke}
                        strokeWidth={shapeModel.strokeWidth}
                        strokeOpacity={shapeModel.strokeOpacity}
                        preserveAspectRatio="none"
                    />
                    {
                        !shapeModel.isGrouped ?
                            <foreignObject>
                                <a id={'interactiveElement_' + this.props.shapeModel.uuid} href='' ref='focusableElement' onFocus={this.onFocusHandler} onKeyDown={this.onKeyDown}></a>
                            </foreignObject >
                            : null
                    }
                </g>
            </InteractiveNonRectangularShape>
    );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/slide/shapes/Curve.js
 **/